import { TransitionPage } from '@vindr/ui';
import { LANGUAGES } from '@vindr/services/constants/common.constant';
import { useGlobalContext } from '#contexts/GlobalContext';
import i18n from '@ohif/i18n';
import { LoadingBar } from '@vindr/ui';
import { Suspense, useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RouteMap from './routes';
import { isMobile } from '@vindr/utils/mobile';

const App = (): JSX.Element => {
  useEffect(() => {
    const defaultLang = localStorage.getItem('defaultLanguage') || LANGUAGES.VI;

    i18n.changeLanguage(defaultLang);
  }, []);

  const { iframe } = useGlobalContext();
  const [iframeState, , setCloseIframe] = iframe;
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!window?.config?.mobileWorkspace) return;
    if (!isMobile()) return;

    const isProd = process.env.NODE_ENV === 'production';

    const URL = `${isProd ? window.location.origin : 'http://localhost:3010'}/m${
      window.location.pathname
    }${window.location.search}`;

    window.location.assign(URL);
  }, [navigate, pathname]);

  useEffect(() => {
    const acceptOpenSplit = ['/studylist', '/worklist', '/assigned'];

    if (!acceptOpenSplit.includes(pathname)) {
      setCloseIframe();
    }
  }, [pathname]);

  if (window?.config?.mobileWorkspace && isMobile()) return null;

  return (
    //! Be careful check mobile before change
    <div className="flex h-full w-full">
      <div
        className={`flex h-full flex-col bg-background-light-1 fill-[#000] text-black dark:bg-background-dark-1 dark:fill-[#fff] dark:text-white ${
          iframeState.open ? 'w-1/2' : 'w-full'
        }`}
        style={{
          transition: 'width 0.15s ease-out',
          willChange: 'width',
        }}
      >
        <Suspense fallback={<LoadingBar />}>
          <TransitionPage fade={false} className="flex h-0 flex-auto flex-col">
            <RouteMap />
          </TransitionPage>
        </Suspense>
      </div>
      {iframeState.open && <iframe className="w-1/2" src={iframeState.url} title="VinDr Viewer" />}
    </div>
  );
};

export default App;
